/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PspChannelR = t.interface({
  channel_code: t.string,

  enabled: t.boolean,

  payment_types: t.readonlyArray(t.string, "array of string")
});

// optional attributes
const PspChannelO = t.partial({});

export const PspChannel = t.intersection(
  [PspChannelR, PspChannelO],
  "PspChannel"
);

export type PspChannel = t.TypeOf<typeof PspChannel>;
